import React from "react";
import PropTypes from "prop-types";

const SearchInput = ({ placeholder, onSearch }) => {
  return (
    <input
      className="form-control"
      list="datalistOptions"
      id="searchsec"
      placeholder={placeholder}
      onChange={onSearch}
    />
  );
};

SearchInput.propTypes = {
  placeholder: PropTypes.string.isRequired,
  onSearch: PropTypes.func.isRequired,
};

export default SearchInput;
